// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { AlarmTest_abstract } from './../abstract/SagaSchema/AlarmTest_abstract';
export class AlarmTest extends AlarmTest_abstract {}
